<!--
 * @LastEditTime: 2022-11-01 13:43:38
 * @LastEditors: Please set LastEditors
 * @Description: 询匠通服务商认证 审核页
-->
<template>
	<div class="service-provider-layout">
		<div class="service-content">
			<div class="authentication">
				服务商认证-<span>{{ rowData.objectType == '0' ? '个人' : '企业' }}</span>
			</div>
			<el-form ref="applyForm" :model="applyForm" label-width="140px" size="small">
				<!-- 个人认证基本信息 -->
				<div class="person-service mt40" v-if="rowData.objectType == '0'">
					<el-row>
						<el-col :span="9">
							<el-form-item label="姓名：">
								<span>{{ applyForm.sname }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="手机号：">
								<span>{{ applyForm.phone }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="证件类型：">
								<span>{{ applyForm.cardTypeName }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="证件号码：">
								<span>{{ applyForm.idCard }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="性别：">
								<span>{{ applyForm.sex == '1' ? '男' : '女' }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="年龄：">
								<span>{{ applyForm.age }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="从业年限：">
								<span>{{ applyForm.proYears }}年</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="所属地区：">
								<span>{{ applyForm.locationName }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="最高学历：">
								<span>{{ applyForm.educationName }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="毕业院校：">
								<span>{{ applyForm.academy }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="现工作单位：">
								<span>{{ applyForm.unitName }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="职务：">
								<span>{{ applyForm.post }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="邮箱：">
								<span>{{ applyForm.email }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="个人简介：">
								<span>{{ applyForm.intro }}</span>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<!-- 企业认证基本信息 -->
				<div class="tenant-serxice mt40" v-else>
					<el-row>
						<el-col :span="9">
							<el-form-item label="企业名称：">
								<span>{{ applyForm.sname }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="统一社会信用代码：">
								<span>{{ applyForm.creditCode }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="法人代表：">
								<span>{{ applyForm.legal }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="法人代表手机号：">
								<span>{{ applyForm.legalPhone }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="单位类型：">
								<span>{{ applyForm.flatName }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="所属行业：">
								<span>{{ applyForm.industryName }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="注册资本：">
								<span>{{ applyForm.assets }}</span
								>万元
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="企业规模：">
								<span>{{ applyForm.scaleName }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="9">
							<el-form-item label="成立时间：">
								<span>{{ applyForm.foundDate }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<el-form-item label="单位性质：">
								<span>{{ applyForm.companyName }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="单位简介：">
								<span>{{ applyForm.introduction }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="经营范围：">
								<span>{{ applyForm.businessScope }}</span>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<!-- 个人身份证照片 -->
				<el-row v-if="rowData.objectType == '0'">
					<el-col :span="24">
						<el-form-item label="证件照片：">
							<el-col :span="3" v-if="applyForm.cardTypeName !== '身份证'">
								<public-upload ref="idcard_3" isViewMode :viewFilesList="otherList" listType="picture-card"></public-upload>
							</el-col>
							<el-col :span="3" v-if="applyForm.cardTypeName == '身份证'">
								<public-upload ref="idcard_1" isViewMode :viewFilesList="rmList" listType="picture-card"></public-upload>
							</el-col>
							<el-col :span="3" :offset="1" v-if="applyForm.cardTypeName == '身份证'">
								<public-upload ref="idcard_2" isViewMode :viewFilesList="ghList" listType="picture-card"></public-upload>
							</el-col>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 企业营业执照 -->
				<el-row v-else>
					<el-col :span="24">
						<el-form-item label="企业营业执照：">
							<el-col :span="3">
								<public-upload ref="yyzzUpload" isViewMode :viewFilesList="businessList" listType="picture-card"></public-upload>
								<div class="top-item-text2">企业营业执照</div>
							</el-col>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 服务地区 -->
				<el-row>
					<el-col :span="24">
						<el-form-item label="服务地区：">
							<span>{{ applyForm.areaName }}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 服务类型 -->
				<el-row>
					<el-col :span="24">
						<el-form-item label="服务类型：">
							<span>{{ applyForm.typeName }}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="相关证书：">
							<template v-if="rowData.objectType == '0'">
								<el-col :span="3">
									<public-upload ref="idcard_1" isViewMode :viewFilesList="educationCertificate" listType="picture-card"></public-upload>
									<div class="top-item-text2">学历证书</div>
								</el-col>
								<el-col :span="3" :offset="1">
									<public-upload ref="idcard_2" isViewMode :viewFilesList="practice" listType="picture-card"></public-upload>
									<div class="top-item-text2">职称证书</div>
								</el-col>
								<el-col :span="3" :offset="1">
									<public-upload ref="idcard_2" isViewMode :viewFilesList="certificate" listType="picture-card"></public-upload>
									<div class="top-item-text2">执业资格证书</div>
								</el-col>
								<el-col :span="3" :offset="1">
									<public-upload ref="idcard_2" isViewMode :viewFilesList="otherCertificate" listType="picture-card"></public-upload>
									<div class="top-item-text2">其它证书</div>
								</el-col>
							</template>
							<template v-else>
								<el-col :span="3">
									<public-upload ref="idcard_1" isViewMode :viewFilesList="hyzzList" listType="picture-card"></public-upload>
									<div class="top-item-text2">行业资质证书</div>
								</el-col>
								<el-col :span="3" :offset="1">
									<public-upload ref="idcard_2" isViewMode :viewFilesList="jyzzList" listType="picture-card"></public-upload>
									<div class="top-item-text2">经营资质许可</div>
								</el-col>
								<el-col :span="3" :offset="1">
									<public-upload ref="idcard_2" isViewMode :viewFilesList="qtzzList" listType="picture-card"></public-upload>
									<div class="top-item-text2">其它经营资质</div>
								</el-col>
							</template>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-row>
				<el-col :span="24" class="mt20">
					<p>审核记录：</p>
					<vxe-table
						align="center"
						auto-resize
						border
						class="mt20"
						:data="checkData"
						highlight-current-row
						highlight-hover-row
						show-overflow="tooltip"
						show-header-overflow="tooltip"
					>
						<vxe-table-column field="status" title="审核结果">
							<template #default="{ row }">
								<span v-if="row.status == 1">通过</span>
								<span v-else-if="row.status == 2">驳回</span>
							</template>
						</vxe-table-column>
						<vxe-table-column field="upUserSname" title="审核人"></vxe-table-column>
						<vxe-table-column field="updateDate" title="审核时间"></vxe-table-column>
						<vxe-table-column field="remark" title="备注"></vxe-table-column>
					</vxe-table>
				</el-col>
			</el-row>
		</div>
		<div class="footer text-center" :class="{ hidden: mode == 'view' }">
			<el-button icon="el-icon-edit-outline" size="mini" @click="auditDialog">审核</el-button>
		</div>
	</div>
</template>
<script>
import * as API from 'api/modules/audit'
import { mapState } from 'vuex'
export default {
	components: {},
	props: {
		companyId: {
			type: String,
			default: ''
		},
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			// 企业/个人服务商认证基本资料
			applyForm: {},
			checkData: [], //审核记录
			rmList: [], //身份证人像面图片
			ghList: [], //身份证国徽面图片
			otherList: [], //其他证件图片
			businessList: [], //企业营业执照图片
			educationCertificate: [], //学历证书图片
			practice: [], //职称证书图片
			certificate: [], //执业资格证书图片
			otherCertificate: [], //其他证书图片
			hyzzList: [], //行业资格证书图片
			jyzzList: [], //经营资质许可图片
			qtzzList: [] //其它经营资质图片
		}
	},
	created() {
		this.companyId != '' ? this.getCompanyMsg() : this.goBack()
	},
	methods: {
		// 查询企业/个人服务商认证资料
		getCompanyMsg() {
			API.getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				this.applyForm = this.$utils.clone(res.data, true)
				if (this.rowData.objectType == '0') {
					if (res.data.cardTypeName == '身份证') {
						//个人服务商认证
						this.rmList = res.data.rm
						this.ghList = res.data.gh
					} else {
						this.otherList = res.data.otherFiles
					}

					if (res.data.educationCertificate && res.data.educationCertificate.length > 0) {
						res.data.educationCertificate.forEach((item) => {
							this.educationCertificate.push(item.map.fileObject)
						})
					}
					if (res.data.practice && res.data.practice.length > 0) {
						res.data.practice.forEach((item) => {
							this.practice.push(item.map.fileObject)
						})
					}
					if (res.data.certificate && res.data.certificate.length > 0) {
						res.data.certificate.forEach((item) => {
							this.certificate.push(item.map.fileObject)
						})
					}
					if (res.data.otherCertificate && res.data.otherCertificate.length > 0) {
						res.data.otherCertificate.forEach((item) => {
							this.otherCertificate.push(item.map.fileObject)
						})
					}
				} else {
					//企业服务商认证
					this.businessList = res.data.business
					if (res.data.hyzz && res.data.hyzz.length > 0) {
						res.data.hyzz.forEach((item) => {
							this.hyzzList.push(item.fileObject)
						})
					}
					if (res.data.jyzz && res.data.jyzz.length > 0) {
						res.data.jyzz.forEach((item) => {
							this.jyzzList.push(item.fileObject)
						})
					}
					if (res.data.qtzz && res.data.qtzz.length > 0) {
						res.data.qtzz.forEach((item) => {
							this.qtzzList.push(item.fileObject)
						})
					}
				}
				// 审核记录 -- 2025-09-19 替换以前的单独接口
				this.checkData = res.data.applyRecords || []
			})
		},

		// 审查页返回审计代办页
		goBack() {
			this.$router.push({ path: '/audit-affairs-new' })
		},

		// 审查弹框
		auditDialog() {
			let params = {
				id: this.rowData.id,
				busId: this.rowData.busId
			}
			this.$emit('openDia', params)
		}
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),
		mode() {
			return this.$route.query.mode
		}
	}
}
</script>
<style lang="less" scoped>
.service-provider-layout {
	height: 100%;
	overflow-y: auto;
	.service-content {
		padding: 30px 20px;
		position: relative;
		.authentication {
			width: 190px;
			height: 45px;
			line-height: 45px;
			font-size: 16px;
			background-color: #008000;
			text-align: center;
			color: #fff;
			position: absolute;
			left: 0px;
			top: 0px;
		}
		.mt40 {
			margin-top: 40px;
		}
		.top-item-text2 {
			font-size: 12px;
			line-height: 30px;
			color: #666;
			text-align: center;
		}
	}
	.footer {
		position: absolute;
		top: 88px;
		right: 135px;
		.el-button {
			height: 28px !important;
		}
	}
}
</style>
